const BASE = "";

function token(): string {
  return localStorage.getItem("rc_token") ?? "";
}

async function authFetch(path: string, opts?: RequestInit): Promise<any> {
  const res = await fetch(`${BASE}${path}`, {
    ...opts,
    headers: {
      ...opts?.headers,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token()}`
    }
  });
  return res.json();
}

// ═══════════════ Recruit Config ═══════════════

export async function fetchRecruitConfig() {
  return authFetch("/api/cert/recruit");
}

// ═══════════════ Leader Applications ═══════════════

export async function applyForLeader(certLevel: string, certStage: string, message?: string) {
  return authFetch("/api/cert/leaders/apply", {
    method: "POST",
    body: JSON.stringify({ certLevel, certStage, message })
  });
}

export async function fetchMyLeaderStatus() {
  return authFetch("/api/cert/leaders/status");
}

export async function editLeaderApplication(id: number, data: { certLevel?: string; certStage?: string; message?: string }) {
  return authFetch(`/api/cert/leaders/${id}`, {
    method: "PUT",
    body: JSON.stringify(data)
  });
}

export async function withdrawLeaderApplication(id: number) {
  return authFetch(`/api/cert/leaders/${id}`, { method: "DELETE" });
}

// ═══════════════ Cert Groups ═══════════════

export async function fetchCertGroups(certLevel?: string, certStage?: string) {
  const params = new URLSearchParams();
  if (certLevel) params.set("certLevel", certLevel);
  if (certStage) params.set("certStage", certStage);
  const qs = params.toString();
  return authFetch(`/api/cert/groups${qs ? `?${qs}` : ""}`);
}

export async function fetchCertGroupDetail(id: number) {
  return authFetch(`/api/cert/groups/${id}`);
}

export async function fetchMyCertGroups() {
  return authFetch("/api/cert/groups/mine");
}

export async function createCertGroup(data: {
  certLevel: string;
  certStage: string;
  durationWeeks: number;
  rhythmDesc: string;
  maxMembers: number;
  description: string;
  timeSlot?: string;
  cohort?: string;
}) {
  return authFetch("/api/cert/groups", {
    method: "POST",
    body: JSON.stringify(data)
  });
}

export async function joinCertGroup(id: number) {
  return authFetch(`/api/cert/groups/${id}/join`, { method: "POST" });
}

export async function leaveCertGroup(id: number) {
  return authFetch(`/api/cert/groups/${id}/leave`, { method: "POST" });
}

export async function disbandCertGroup(id: number) {
  return authFetch(`/api/cert/groups/${id}/disband`, { method: "POST" });
}

export async function confirmCertGroup(id: number, campStartDate?: string) {
  return authFetch(`/api/cert/groups/${id}/confirm`, {
    method: "POST",
    body: JSON.stringify(campStartDate ? { campStartDate } : {})
  });
}

export async function completeCertGroup(id: number, feedback?: string) {
  return authFetch(`/api/cert/groups/${id}/complete`, {
    method: "POST",
    body: JSON.stringify({ feedback })
  });
}

export async function undoCompleteCertGroup(id: number) {
  return authFetch(`/api/cert/groups/${id}/undo-complete`, { method: "POST" });
}

export async function undoDisbandCertGroup(id: number) {
  return authFetch(`/api/cert/groups/${id}/undo-disband`, { method: "POST" });
}

export async function deleteCertGroup(id: number) {
  return authFetch(`/api/cert/groups/${id}`, { method: "DELETE" });
}

export async function fetchLeaderSop(certStage: string) {
  return authFetch(`/api/cert/sop-leader/${encodeURIComponent(certStage)}`);
}

export async function fetchAdminCertGroups(params?: { certStage?: string; status?: string }) {
  const qs = new URLSearchParams();
  if (params?.certStage) qs.set("certStage", params.certStage);
  if (params?.status) qs.set("status", params.status);
  const q = qs.toString();
  return authFetch(`/api/cert/admin/groups${q ? `?${q}` : ""}`);
}

export async function fetchChecklistAdminStatus(certStage?: string) {
  const qs = certStage ? `?certStage=${encodeURIComponent(certStage)}` : "";
  return authFetch(`/api/checklist/admin/status${qs}`);
}

export async function adminDeleteCertGroup(id: number) {
  return authFetch(`/api/cert/admin/groups/${id}`, { method: "DELETE" });
}

export async function adminGenerateConfirmChecklist(groupId: number) {
  return authFetch(`/api/checklist/admin/generate-confirm/${groupId}`, { method: "POST" });
}
